import styled from 'styled-components';
import { Icon } from 'antd';
import { Tooltip as CustomTooltip } from '../../../../../popovers';


export const UserIcon = styled.img`
  width: 35px;
  height: 35px;
  border-radius: 50%;
  object-fit: cover;
  cursor: pointer;
  outline: none;
  margin-right: 5px;
  border: 2px solid white;
`;

export const CloseIcon = styled(Icon)`
  position: absolute;
  right: 0;
  top: -3px;
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s linear 0.2s, opacity 0.2s linear;

  &.show {
    visibility: visible;
    opacity: 1;
    transition-delay: 0s;
  }
`;

export const Tooltip = styled(CustomTooltip)`
  position: relative;
`;

export const CloseIconWrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;

  svg {
    display: inline-block;
    margin-right: 8px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/requests-list-item/request-header/request-assignees/assignees-list/assignees-list-item/styled-components.js